// eslint-disable-next-line import/prefer-default-export
export function notifySignUpSuccess() {
  if (window.isEmbedded()) {
    window.parent.postMessage(
      {
        message: 'signup/success',
      },
      '*',
    );
  }
}
